module.exports = __webpack_public_path__ + "img/prizeIntegral.93508c84.png";